import React from 'react';
import { SettingsProductsTab } from './SettingsProducts';
import { SettingsClientsTab } from './SettingsClients';
import { SettingsCostRulesTab } from './SettingsCostRules';

const Settings = () => {
  return <SettingsProductsTab />;
};

export const ProductsTab = () => {
  return <SettingsProductsTab />;
};

export const ClientsTab = () => {
  return <SettingsClientsTab />;
};

export const CostRulesTab = () => {
  return <SettingsCostRulesTab />;
};

export default Settings;